export class RestoreEksNamespaceConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tags",
            "baseName": "tags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "volumeSettings",
            "baseName": "volumeSettings",
            "type": "Array<RestoreEksNamespaceVolumeInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return RestoreEksNamespaceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
